var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40168 1.1792H5.59811C5.52668 1.1792 5.49097 1.21491 5.49097 1.28634V5.4917H1.50021C1.42878 5.4917 1.39307 5.52741 1.39307 5.59884V6.40241C1.39307 6.47384 1.42878 6.50956 1.50021 6.50956H5.49097V10.7149C5.49097 10.7863 5.52668 10.8221 5.59811 10.8221H6.40168C6.47311 10.8221 6.50882 10.7863 6.50882 10.7149V6.50956H10.5002C10.5716 6.50956 10.6074 6.47384 10.6074 6.40241V5.59884C10.6074 5.52741 10.5716 5.4917 10.5002 5.4917H6.50882V1.28634C6.50882 1.21491 6.47311 1.1792 6.40168 1.1792Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.b1f116fe0a02dc0febd54add726bd9df.svg";
export { ForwardRef as ReactComponent };